import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { MFAChannel } from '@/modules/user/components/SignIn/MultiFactorAuthentication/mfa.types';

interface Payload {
  channel: MFAChannel;
  session: string;
}

interface Props {
  isRequiredExpressSetup?: boolean;
}

const useSendMFACodeQuery = ({ isRequiredExpressSetup }: Props) => {
  const { mutateAsync, isError, isLoading } = useMutation((value: Payload) =>
    api.post(isRequiredExpressSetup ? API_URL.CONTACTS_CODES : API_URL.CONTACTS_MFA_CODES, {
      channel: {
        type: value.channel.type,
        value: value.channel.value,
      },
      session: value.session,
    })
  );

  return {
    sendMFACode: mutateAsync,
    isError,
    isLoading,
  };
};

export default useSendMFACodeQuery;
